import { createSelector } from '@ngrx/store';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { notificationsAdapter } from './notifications.reducer';

export const getNotificationsState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => state?.notifications,
);

export const {
  selectIds: getNotificationsIds,
  selectEntities: getNotificationsEntities,
  selectAll: getNotificationsAll,
  selectTotal: getNotificationsTotal,
} = notificationsAdapter.getSelectors(getNotificationsState);

export const getNotificationsTotalUnread = createSelector(
  getNotificationsState,
  ({ totalUnread }) => totalUnread,
);

export const getNotificationsLoading = createSelector(
  getNotificationsState,
  ({ loading }) => loading,
);

export const getNotificationsError = createSelector(getNotificationsState, ({ error }) => error);

export const getNotificationsPageNumber = createSelector(getNotificationsState, ({ page }) =>
  !!page ? page.number : 0,
);

export const isNotificationsLastPage = createSelector(
  getNotificationsState,
  ({ page }) => !!page && page.last,
);
